module.exports = __webpack_public_path__ + "public/images/diplom.5b9c6384c1565503bc42d671b25cba14.svg";